import { useLocation } from "react-router-dom";
import "./OrdersDetials.scss";
import { useNavigate } from "react-router-dom";
import CommaSeparator from "../../../../Utils/CommaSeparator";

const OrdersDetails = () => {
  const location = useLocation();
  const orderDetailsDataArray = location.state?.orderDetails || [];
  const navigateTo = useNavigate();

  const moveToOrdershandle = () => {
    navigateTo("/Orders");
  };

  return (
    <div className="OrdersDetails">
      {orderDetailsDataArray.map((orderDetails, index) => (
        <div className="Details" key={index}>
          <div className="OrderCodeDetails">
            <span>کد سفارش :</span>
            <span className="codeDetails">{orderDetails.orderId}</span>
          </div>
          <div className="cardOrdersDetails">
            <div className="imageleft">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                onClick={() => moveToOrdershandle()}
              >
                <path
                  d="M12 22.75C6.07 22.75 1.25 17.93 1.25 12C1.25 6.07 6.07 1.25 12 1.25C17.93 1.25 22.75 6.07 22.75 12C22.75 17.93 17.93 22.75 12 22.75ZM12 2.75C6.9 2.75 2.75 6.9 2.75 12C2.75 17.1 6.9 21.25 12 21.25C17.1 21.25 21.25 17.1 21.25 12C21.25 6.9 17.1 2.75 12 2.75Z"
                  fill="#EE6900"
                />
                <path
                  d="M13.2599 16.2802C13.0699 16.2802 12.8799 16.2102 12.7299 16.0602L9.19992 12.5302C8.90992 12.2402 8.90992 11.7602 9.19992 11.4702L12.7299 7.94016C13.0199 7.65016 13.4999 7.65016 13.7899 7.94016C14.0799 8.23016 14.0799 8.71016 13.7899 9.00016L10.7899 12.0002L13.7899 15.0002C14.0799 15.2902 14.0799 15.7702 13.7899 16.0602C13.6499 16.2102 13.4599 16.2802 13.2599 16.2802Z"
                  fill="#EE6900"
                />
              </svg>
            </div>
            <div className="rowDetails">
              <div className="date">
                <span>تاریخ</span>
                <div className="backendDate">
                  <span>
                    {orderDetails.date} ، {orderDetails.Time}{" "}
                  </span>
                </div>
              </div>
              <div className="Amount">
                <div className="imageCircle">
                  <svg
                    width="4"
                    height="4"
                    viewBox="0 0 4 4"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="2" cy="2" r="2" fill="#DADADA" />
                  </svg>
                </div>
                <span>مبلغ</span>
                <div className="backendAmount">
                  <span>{CommaSeparator(orderDetails.totalAmount)}ریال</span>
                </div>
              </div>
              <div className="Discount">
                <div className="imageCircle">
                  <svg
                    width="4"
                    height="4"
                    viewBox="0 0 4 4"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="2" cy="2" r="2" fill="#DADADA" />
                  </svg>
                </div>
                <span>تخفیف</span>
                <div className="backendDiscount">
                  <span>{CommaSeparator(orderDetails.offer)} ریال</span>
                </div>
              </div>
              {/* <div className="tax">
                <div className="imageCircle">
                  <svg
                    width="4"
                    height="4"
                    viewBox="0 0 4 4"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="2" cy="2" r="2" fill="#DADADA" />
                  </svg>
                </div>
                <span>مالیات</span>
                <div className="backendtax">
                  <span>{CommaSeparator(orderDetails.tax)} ریال</span>
                </div>
              </div> */}
              <div className="PackagingAndShipping">
                <div className="imageCircle">
                  <svg
                    width="4"
                    height="4"
                    viewBox="0 0 4 4"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="2" cy="2" r="2" fill="#DADADA" />
                  </svg>
                </div>
                <span>بسته بندی و ارسال</span>
                <div className="backendPackagingAndShipping">
                  <span>{CommaSeparator(orderDetails.shippingCost)} ریال</span>
                </div>
              </div>
            </div>
            <div className="rowDetails">
              <div className="Transferee">
                <span>تحویل گیرنده</span>
                <div className="backendTransferee">
                  <span>{orderDetails.receiverDelivery}</span>
                </div>
              </div>
              <div className="MobileNum">
                <div className="imageCircle">
                  <svg
                    width="4"
                    height="4"
                    viewBox="0 0 4 4"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="2" cy="2" r="2" fill="#DADADA" />
                  </svg>
                </div>
                <span>شماره موبایل</span>
                <div className="backendMobileNum">
                  <span>{orderDetails.mobile}</span>
                </div>
              </div>
              <div className="PostalCode">
                <div className="imageCircle">
                  <svg
                    width="4"
                    height="4"
                    viewBox="0 0 4 4"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="2" cy="2" r="2" fill="#DADADA" />
                  </svg>
                </div>
                <span>کدپستی</span>
                <div className="backendPostalCode">
                  <span>{orderDetails.PostalCode}</span>
                </div>
              </div>
            </div>
            <div className="address">
              <span>آدرس</span>
              <div className="backendaddress">
                <span>{orderDetails.address}</span>
              </div>
            </div>
          </div>
          <div className="BigCardDetails">
            <div className="rowDetails">
              <div className="DeliveryTime">
                <span>زمان تحویل</span>
                <div className="backendDeliveryTime">
                  <span>{orderDetails.DeliveryTime}</span>
                </div>
              </div>
              <div className="TrackingCode">
                <div className="imageCircle">
                  <svg
                    width="4"
                    height="4"
                    viewBox="0 0 4 4"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="2" cy="2" r="2" fill="#DADADA" />
                  </svg>
                </div>
                <span>کد پیگیری مرسوله</span>
                <div className="backendTrackingCode">
                  <span>{orderDetails.TrackingCode}</span>
                </div>
              </div>
            </div>
            <div className="rowCardOrder">
              {orderDetails.items.map((item, itemIndex) => (
                <div className="cardInOrderCard" key={itemIndex}>
                  <div className="imageCommodity">
                    <img src={item.image} alt="" />
                  </div>
                  <div className="columnNameAndNum">
                    <span className="Titel">{item.productName}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default OrdersDetails;
